export enum TopBarSlimThemes {
  info = 'info',
  warning = 'warning',
}

export enum UseCaseVariationEnums {
  create = 'create',
  collect = 'collect',
  analyze = 'analyze',
}
